import { ErrorHandler } from "@angular/core";
import { HttpConnectorError } from "../models/http-connector-error.model";
import { ErrorHandlingService } from '../services/error-handling.service';
import { LocatorService } from '../services/locator.service';

export class SmErrorHandler implements ErrorHandler {

    static instance: SmErrorHandler;
    onError: ((error: any) => void)[] = [];

    constructor() {
        SmErrorHandler.instance = this;
    }

    handleError(error: any): void {
        if (error?.name == "Canceled" && error?.stack?.includes("TextDiffComponent")) {
            return;
        }

        for (let f of this.onError) {
            f(error);
        }

        if (error instanceof HttpConnectorError) {
            if (error.isBackendUnavailable()) {
                console.warn("Das Backend ist vorübergehend nicht erreichbar (" + (error.response.status == 0 ? "keine HTTP-Antwort" : "HTTP " + error.response.status) + "): " + (error.response.url ?? "URL unbekannt"));
                return;
            }
            if (error.response.status == 500 || error.response.status == 401 && error.response.message.includes("Unauthorized")) {
                return;
            }
        }

        let dynamicImportUrl = SmErrorHandler.getFailedDynamicImportUrl(error);
        if (dynamicImportUrl != null) {
            void this.handleDynamicImportError(error, dynamicImportUrl);
            return;
        }

        console.log(error);
        console.trace(error);

        LocatorService.injector.get(ErrorHandlingService).reportToBackend(error as Error);
    }

    private static getFailedDynamicImportUrl(error: any): string {
        let message = typeof error?.message == "string" ? error.message as string : "";
        return /^(?:Failed to fetch dynamically imported module|error loading dynamically imported module): (\S+)/i.exec(message)?.[1] ?? null;
    }

    // Nicht ladbare Code-Chunks werden nur gemeldet, wenn die Datei auf dem erreichbaren Server tatsächlich fehlt
    private async handleDynamicImportError(error: any, url: string): Promise<void> {
        try {
            let response = await fetch(url, {method: "HEAD", cache: "no-store"});
            if (response.ok) {
                console.warn("Ein Code-Chunk konnte vorübergehend nicht geladen werden und ist inzwischen wieder verfügbar: " + url);
                return;
            }
        }
        catch {
            console.warn("Das Backend ist vorübergehend nicht erreichbar, ein Code-Chunk konnte nicht geladen werden: " + url);
            return;
        }

        console.log(error);
        console.trace(error);
        LocatorService.injector.get(ErrorHandlingService).reportToBackend(error as Error);
    }

    handleBackendError(errorId: string): void {
        LocatorService.injector.get(ErrorHandlingService).reportToBackend(new Error(), errorId);
    }
}
